export function lastUrl (state) {
  return state.lastUrl
}

export function patientPrivacyUrl(state) {
  return state.patientPrivacyUrl
}

export function patientPrivacyUrlLabel(state) {
  return state.patientPrivacyUrlLabel
}

export function sidenavLinks(state) {
  return state.sidenavLinks
} 



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/website/getters.js
// module id = null
// module chunks = 